import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class OperatorSigningLogsService {
    private basePath = environment.interop.basePath;

    constructor(private http: HttpClient) {}

    getOperatorSigningLogs(params: any): Observable<any> {
        const url = `${this.basePath}api/registratura/document/operator-signature/logs`;
        return this.http.get<any>(url, {
            params: this.buildParams(params)
        });
    }

    getOperatorSigningLogDetail(logId: number): Observable<any> {
        const url = `${this.basePath}api/registratura/document/operator-signature/logs/${logId}`;
        return this.http.get<any>(url);
    }

    getStatuses(): Observable<any> {
        const url = `${this.basePath}api/registratura/document/operator-signature/logs/statuses`;
        return this.http.get<any>(url);
    }

    exportCsv(params: any): Observable<Blob> {
        const url = `${this.basePath}api/registratura/document/operator-signature/logs/export/csv`;
        return this.http.get(url, {
            params: this.buildParams(params),
            responseType: 'blob'
        });
    }

    private buildParams(params: any): HttpParams {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return httpParams;
    }
}
